/**
 * Capture screens flag captured-but-unsaved media here; the page-level close
 * handler reads it to nudge "save as draft?" before letting the participant
 * leave. A module flag (not context/props) because five capture components
 * would otherwise each need a new prop threaded for one boolean.
 *
 * ponytail: flags ANY present media as unsaved — a resumed, unmodified draft
 * also nudges on exit. Safe direction; track per-capture modification like
 * AudioCapture's `modified` if the extra nudge proves annoying.
 */
let unsaved = false;

export const setUnsavedCapture = (v: boolean): void => { unsaved = v; };
export const hasUnsavedCapture = (): boolean => unsaved;
